/** Default delegated selector for in-frame trigger and prefetch discovery. */
export const DEFAULT_LISTEN_SELECTOR =
  "[data-frame-url],[data-frame-query],[data-frame-cache],[data-frame-selector],[data-frame-source-selector],[data-frame-target],[data-frame-submit]";

/** Default state-preservation tokens applied when `preserve-state` is omitted. */
export const DEFAULT_PRESERVE_STATE = "focus,value,selection,scroll";

/** Canonical remote-frame attribute names used across parsing and observers. */
export enum FrameAttribute {
  Src = "src",
  SourceSelector = "source-selector",
  Selector = "selector",
  Select = "select",
  Shopify = "shopify",
  SectionId = "section-id",
  Cache = "cache",
  CacheTtlMs = "cache-ttl-ms",
  CacheMaxEntries = "cache-max-entries",
  UrlBase = "url-base",
  Query = "query",
  ListenHistory = "listen-history",
  History = "history",
  HistoryScope = "history-scope",
  HistoryParams = "history-params",
  InitialFetch = "initial-fetch",
  PreserveState = "preserve-state",
  LoadingClass = "loading-class",
  SubmittingClass = "submitting-class",
  ListenEvents = "listen-events",
  ListenSelector = "listen-selector",
  PrefetchEvents = "prefetch-events",
  PrefetchSelector = "prefetch-selector",
  DocumentEvents = "document-events",
  Lazy = "lazy",
  PollMs = "poll-ms",
  ExecuteScripts = "execute-scripts",
  TimeoutMs = "timeout-ms",
  Credentials = "credentials",
  Debug = "debug",
  BroadcastRefresh = "broadcast-refresh",
  BroadcastEventPrefix = "broadcast-event-prefix",
  BroadcastMaxHop = "broadcast-max-hop",
  BroadcastReemit = "broadcast-reemit",
  ListenRefreshFrom = "listen-refresh-from",
  ListenRefreshUrlMode = "listen-refresh-url-mode",
  ListenRefreshQueryKeys = "listen-refresh-query-keys",
}

/** Attribute list observed by the remote-frame custom element. */
export const OBSERVED_ATTRIBUTES = [
  FrameAttribute.Src,
  FrameAttribute.SourceSelector,
  FrameAttribute.Selector,
  FrameAttribute.Select,
  FrameAttribute.Shopify,
  FrameAttribute.SectionId,
  FrameAttribute.Cache,
  FrameAttribute.CacheTtlMs,
  FrameAttribute.CacheMaxEntries,
  FrameAttribute.UrlBase,
  FrameAttribute.Query,
  FrameAttribute.ListenHistory,
  FrameAttribute.History,
  FrameAttribute.HistoryScope,
  FrameAttribute.HistoryParams,
  FrameAttribute.InitialFetch,
  FrameAttribute.PreserveState,
  FrameAttribute.LoadingClass,
  FrameAttribute.SubmittingClass,
  FrameAttribute.ListenEvents,
  FrameAttribute.ListenSelector,
  FrameAttribute.PrefetchEvents,
  FrameAttribute.PrefetchSelector,
  FrameAttribute.DocumentEvents,
  FrameAttribute.Lazy,
  FrameAttribute.PollMs,
  FrameAttribute.ExecuteScripts,
  FrameAttribute.TimeoutMs,
  FrameAttribute.Credentials,
  FrameAttribute.Debug,
  FrameAttribute.BroadcastRefresh,
  FrameAttribute.BroadcastEventPrefix,
  FrameAttribute.BroadcastMaxHop,
  FrameAttribute.BroadcastReemit,
  FrameAttribute.ListenRefreshFrom,
  FrameAttribute.ListenRefreshUrlMode,
  FrameAttribute.ListenRefreshQueryKeys,
] as const;
